import React from "react";
import PropTypes from "prop-types";
import { getEditorialTag, getLang } from "../../../Utils/utils";
import "./EditorialTag.css";

const EditorialTag = ({ editorialTags, className = "" }) => {
  const locale = getLang();
  const editorialTag = getEditorialTag(editorialTags, locale);

  const style = {
    backgroundColor: editorialTag.backgroundColor,
    color: editorialTag.textColor,
  };

  return (
    <div
      className={`VideoEditorialTag ${className}`}
      style={style}
    >
      {editorialTag.title.toUpperCase()}
    </div>
  );
};

EditorialTag.propTypes = {
  editorialTags: PropTypes.array,
  className: PropTypes.string
};

export default EditorialTag;
